
<template>
    <Tab2Comp />
  </template>
  
  <script>
  import Tab2Comp from '@/components/RecruitmentTab2.vue';
  
    export default {
        name: "Tab2Vue",
        components: {
            Tab2Comp
        }
    }
  
  </script>